import React from 'react';
import './index.css';
import Navbar from './components/Navbar';
import DemoBanner from './components/DemoBanner';
import Hero from './components/Hero';
import WhyRS from './components/WhyRS';
import Courses from './components/Courses';
import About from './components/About';
import Testimonials from './components/Testimonials';
import DemoCTA from './components/DemoCTA';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function App() {
  return (
    <>
      <DemoBanner />
      <Navbar />
      <main>
        <Hero />
        <WhyRS />
        <Courses />
        <About />
        <Testimonials />
        <DemoCTA />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
